export enum ImageColor {
  'linear-gradient(180deg, #03EC44 0%, #048829 100%)',
  'linear-gradient(180deg, #03C2EC 0%, #044988 100%)',
  'linear-gradient(180deg, #ECE303 0%, #CE9501 100%)',
  'linear-gradient(180deg, #7803EC 0%, #850488 100%)',
}
